import React from 'react';

import PropTypes from 'prop-types';

import { BlockFormControl } from '../../css';
import { useLocalizedStringsContext } from '../../../../../../../../context/LocalizedStringsContext';

import { useLocaleContext } from '../../../../../../../../context/LocaleContext';
import EN from '../../../../../../../../../EN.json';
import FR from '../../../../../../../../../FR.json';
import FormControlItem from './formControlItem';

const FormControlPanel = ({ id, formTypes, fetchData }) => {
  const local = useLocaleContext()

  const {
    DEFECT_MANAGEMENT: { accessControlFormsList } }
    = local === 'en-US' ? EN : FR;

  const updatedFormType =
    formTypes ||
    accessControlFormsList.reduce(
      (acc, current) => ({ ...acc, ...(current.key ? {[current.key]: false}: {}) }),
      {}
    );
  return (
    <>
      <BlockFormControl>
        {accessControlFormsList.map(itemData => (
          <FormControlItem
            data={itemData}
            id={id}
            formTypes={updatedFormType}
            fetchData={fetchData}
          />
        ))}
      </BlockFormControl>
    </>
  );
};

FormControlPanel.propTypes = {
  id: PropTypes.number.isRequired,
  formTypes: PropTypes.shape({
    disableBrp: PropTypes.bool,
    disableReferral: PropTypes.bool,
    disableWireless: PropTypes.bool,
    disableWireline: PropTypes.bool
  }).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default FormControlPanel;
